<style>
    .c-week-selector .c-popover-selector, .c-popover-selector {
        border:none;
    }
</style>
<template>
    <div class="c-week-selector">
        <b-button-group>
            <b-button @click="reset" class="btn btn-light mr-1">{{Core.Definition.getDefinition('Auj.')}}</b-button>
            <b-button @click="minus" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonTextColor', '', Core.Value.typeColor)}"><i class="fa fa-chevron-left"></i></b-button>
            <b-button class="btn btn-light">{{Vue.moment(dataValue.start).format('DD')}} - {{Vue.moment(dataValue.end).format(options.date.displayFormat)}}</b-button>
            <b-button @click="plus" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonTextColor', '', Core.Value.typeColor)}"><i class="fa fa-chevron-right"></i></b-button>
            <b-button id="popoverDate" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonTextColor', '', Core.Value.typeColor)}" class="mr-1"><i class="fa fa-calendar"></i></b-button>
        </b-button-group>
        <b-popover placement="bottom" class="text-center c-popover-selector" ref="popoverDate" target="popoverDate">
            <InputDatePicker
                    :isInline="true"
                    v-model="dataDate">
            </InputDatePicker>
        </b-popover>
    </div>
</template>

<script>
    import InputDatePicker from './InputDatePicker'
    import Vue from 'vue'

    Vue.use(require('vue-moment'))
    export default {
        name: 'WeekPagination',
        components: {
            InputDatePicker
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        date: {
                            firstDayOfWeek: 'monday',
                            displayFormat: 'DD MMM YYYY'
                        }
                    }
                }
            },
            value: {
                type: Object,
                default: function () {
                    return {
                        start: '',
                        end: ''
                    }
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue: {
                handler(val) {
                    this.$refs.popoverDate.$emit('close')
                    this.$emit('input', val)
                },
                deep: true
            },
            dataDate(val) {
                let startOf = 'isoWeek'
                if (this.options.date.firstDayOfWeek === 'sunday') {
                    startOf = 'week'
                }
                this.dataValue.start = Vue.moment(val).startOf(startOf).format('YYYY-MM-DD')
                this.dataValue.end = Vue.moment(val).endOf(startOf).format('YYYY-MM-DD')
            }
        },
        mounted() {
            this.reset()
        },
        data: () => {
            return {
                Vue: Vue,
                Core: window.Core,
                dataValue: {
                    start: '',
                    end: ''
                },
                dataDate: new Date()
            }
        },
        methods: {
            plus() {
                let startOf = 'isoWeek'
                if (this.options.date.firstDayOfWeek === 'sunday') {
                    startOf = 'week'
                }
                this.dataValue.start = Vue.moment(this.dataValue.start).add('week', 1).startOf(startOf).format('YYYY-MM-DD')
                this.dataValue.end = Vue.moment(this.dataValue.end).add('week', 1).endOf(startOf).format('YYYY-MM-DD')
            },
            minus() {
                let startOf = 'isoWeek'
                if (this.options.date.firstDayOfWeek === 'sunday') {
                    startOf = 'week'
                }
                this.dataValue.start = Vue.moment(this.dataValue.start).add('week', -1).startOf(startOf).format('YYYY-MM-DD')
                this.dataValue.end = Vue.moment(this.dataValue.end).add('week', -1).endOf(startOf).format('YYYY-MM-DD')
            },
            reset() {
                let startOf = 'isoWeek'
                if (this.options.date.firstDayOfWeek === 'sunday') {
                    startOf = 'week'
                }
                this.dataDate = new Date()
                this.dataValue.start = Vue.moment().startOf(startOf).format('YYYY-MM-DD')
                this.dataValue.end = Vue.moment().endOf(startOf).format('YYYY-MM-DD')
            }
        }
    }
</script>